import type { WarpwayConfig } from './types';

/**
 * Parse data attributes from the script tag
 */
export function parseConfig(): WarpwayConfig {
  // Match script tags with 'sdk' in the src (supports versioned filenames like sdk-v0.1.1.js)
  const scriptTag = document.querySelector('script[src*="sdk"][data-warp-site]') as HTMLScriptElement;

  if (!scriptTag) {
    console.warn('[Warpway SDK] Script tag not found');
    return getDefaultConfig();
  }

  const siteId = scriptTag.dataset.warpSite;
  const devParam = scriptTag.dataset.warpDev || 'query:param:warpway=dev';
  const widgetEnabled = scriptTag.dataset.warpWidget !== 'off';

  // Parse dev mode query param
  // Format: "query:param:warpway=dev" -> check if ?warpway=dev exists
  const devMode = checkDevMode(devParam);

  return {
    siteId,
    devMode,
    widgetEnabled,
    devQueryParam: devParam,
  };
}

/**
 * Check if dev mode is active based on query parameter
 */
function checkDevMode(devParam: string): boolean {
  // Parse format: "query:param:KEY=VALUE"
  const match = devParam.match(/query:param:([^=]+)=(.+)/);

  if (!match) {
    console.warn('[Warpway SDK] Invalid dev param format:', devParam);
    return false;
  }

  const [, key, value] = match;
  const urlParams = new URLSearchParams(window.location.search);

  return urlParams.get(key) === value;
}

/**
 * Default configuration
 */
function getDefaultConfig(): WarpwayConfig {
  return {
    devMode: false,
    widgetEnabled: false,
    devQueryParam: 'query:param:warpway=dev',
  };
}
